module.exports = __webpack_public_path__ + "media/images/talent/case-after-93e24907248e915f6f86fdfedb033f27.png";